// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextFormattingMenuInput__input-d6e67d {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-4);
  color: var(--base-110);
}

.TextFormattingMenuInput__input-d6e67d::placeholder {
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/components/TextFormattingInput/TextFormattingMenu/components/TextFormattingMenuInput/TextFormattingMenuInput.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,qCAAA;EACA,sBAAA;AACF;;AAEA;EACE,qBAAA;AACF","sourcesContent":[".input {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-4);\n  color: var(--base-110);\n}\n\n.input::placeholder {\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `TextFormattingMenuInput__input-d6e67d`
};
module.exports = ___CSS_LOADER_EXPORT___;
